import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=3fa8bd7b&"
import script from "./SignaturePad.vue?vue&type=script&lang=js&"
export * from "./SignaturePad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa8bd7b')) {
      api.createRecord('3fa8bd7b', component.options)
    } else {
      api.reload('3fa8bd7b', component.options)
    }
    module.hot.accept("./SignaturePad.vue?vue&type=template&id=3fa8bd7b&", function () {
      api.rerender('3fa8bd7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/SignaturePad.vue"
export default component.exports